import request from "@/utils/request";
const baseUrl = process.env.VUE_APP_APP_API + "/web/business-notice";
// 信息发布
const infoApi = {
  // 信息列表, 分页
  page(params) {
    return request({
      url: `${baseUrl}/page`,
      method: "GET",
      params
    });
  },
  // 信息发布 详情
  detail(id) {
    return request({
      url: `${baseUrl}/get`,
      method: "GET",
      params: { id }
    });
  },
  // 更新信息发布浏览量
  updateView(id) {
    return request({
      url: `${baseUrl}/updateView`,
      method: "POST",
      params: { id }
    });
  }
};
export default infoApi;
